import { render, staticRenderFns } from "./PaginationRight.vue?vue&type=template&id=517bbf62&"
import script from "./PaginationRight.vue?vue&type=script&lang=ts&"
export * from "./PaginationRight.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationRight.vue?vue&type=style&index=0&id=517bbf62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports